<template>
  <div class="voting">
    <div v-show="!isCompleted">
      <select class="form-control form-control-lg" v-model="voteUid">
        <option :value="member.uid" v-for="member in members"  :key="member.id">{{ member.name }}</option>
      </select>
      <button type="button" name="button" class="btn btn-primary" @click="vote">投票</button>
    </div>
    <div v-show="isCompleted">
      投票しました。
    </div>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'Voting',
  props: {
    members: Array,
    user: null,
    room_id: String
  },
  data() {
    return {
      db: null,
      voteUid: null,
      isCompleted: false
    }
  },
  methods: {
    vote() {
      const data = {from: this.user.uid, to: this.voteUid};
      this.db.collection('rooms').doc(this.room_id).update({
        votes: firebase.firestore.FieldValue.arrayUnion(data)
      }).then(()=>{
        this.isCompleted = true;
      })
    }
  },
  created() {
    this.db = firebase.firestore();
    this.voteUid = this.members[0].uid;
  }
}
</script>
<style scoped>
</style>
